module.exports = __webpack_public_path__ + "img/aboutimg1.8ca5d019.jpg";